import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { getPpvRateWithCountsTooltipFormatter, mapIdsToLabels } from './chartUtils';

const OrganizationChatterPpvRateByChatterChart = ({ data, chatterLabelMap, pending }) => {
  const { categories, series, tooltipFormatter } = useMemo(() => {
    const chatterIds = data?.chatterIds || [];
    const ppvRate = data?.ppvRate || [];
    const offerCount = data?.offerCount || [];
    const purchaseCount = data?.purchaseCount || [];
    const rows = chatterIds
      .map((chatterId, index) => ({
        category: mapIdsToLabels([chatterId], chatterLabelMap)[0],
        ppvRate: Number(ppvRate[index] || 0),
        offerCount: Number(offerCount[index] || 0),
        purchaseCount: Number(purchaseCount[index] || 0),
      }))
      .sort(
        (firstRow, secondRow) =>
          secondRow.ppvRate - firstRow.ppvRate || firstRow.category.localeCompare(secondRow.category),
      );

    return {
      categories: rows.map(row => row.category),
      series: [
        {
          name: 'Conversion Rate',
          data: rows.map(row => row.ppvRate),
          offerCount: rows.map(row => row.offerCount),
          purchaseCount: rows.map(row => row.purchaseCount),
        },
      ],
      tooltipFormatter: getPpvRateWithCountsTooltipFormatter(),
    };
  }, [data, chatterLabelMap]);

  return (
    <OrganizationAnalyticsBarChart
      title="Conversion Rate By Chatter"
      subtitle="Conversion rate for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators and chatters to load conversion rate."
      valueType="percent"
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationChatterPpvRateByChatterChart;
